export default __webpack_public_path__ + "static/media/100_19584.e5e94d75.jpg";